import {getService, getServiceAuthorized, postService, postServiceAuthorized, postServiceFormData, postServiceFormDataAuthorized} from '../configs/FetchRequest';
import { route } from '../constants/routePath';
import AxiosRequest from '../configs/api';

const ProductService = {};
ProductService.allCatalogue = () => AxiosRequest.get(
    `/${route.productCatalog}/catalognodes/categories/v2`,
    
  )
ProductService.allCatalogueProduct = (pageNo,catid,searchText) => AxiosRequest.get(
    `/${route.productCatalog}/catalognodes/products/v3?pageNo=${pageNo}&productCtgryId=${catid}&productName=${searchText}&productPrice=`,
  )
  //Product Details
ProductService.productDetailsWeb = (productId,catid) => AxiosRequest.get(
    `/${route.productCatalog}/catalognodes/products/productById?productId=${productId}&productCtgryId=${catid}`,
  )

  ProductService.bannerDashboard = () => AxiosRequest.get(
    `/${route.productCatalog}/catalognodes/contentspots/homeBannerWebApp?tag_id`
  )
  

export default ProductService;